// extracted by mini-css-extract-plugin
export default {"pageHeader":"GpsPetitions_pageHeader__eKaZ9","pageTitle":"GpsPetitions_pageTitle__p32u5","filters":"GpsPetitions_filters__r0S1s","statusFilter":"GpsPetitions_statusFilter__yOzqU"};